// extracted by mini-css-extract-plugin
export default {"feedbackBtn":"Button_feedbackBtn__8za-J"};